import axios from '@/utils/axios'

/**
 * 清洗规则-规则列表
 */
export function ruleList(parameter) {
  return axios.formRequest.post('flow/website/flow_rule/ruleList', parameter)
}

/**
 * 清洗规则-删除
 */
export function delRule(id) {
  return axios.formRequest.post('flow/website/flow_rule/delRule', { id })
}

/**
 * 清洗规则-添加
 */
export function addRule(parameter) {
  return axios.formRequest.post('flow/website/flow_rule/addRule', parameter)
}

/**
 * 清洗规则-编辑
 */
export function editorRule(parameter) {
  return axios.formRequest.post('flow/website/flow_rule/editorRule', parameter)
}

/**
 * 清洗规则-详情
 */
export function getDetail(id) {
  return axios.formRequest.post('flow/website/flow_rule/getDetail', { id })
}
